/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { contactSchema } from './contact-schema';
import { userSettingSchema } from './user-setting-schema';
import { CountryCode, Role } from "../enums";

export const userSchema: z.AnyZodObject = z.object({
  bullhornId: z.string().nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  email: z.string().nullish(),
  firstLoginAt: z.string().datetime().nullish(),
  firstName: z.string().nullish(),
  fullName: z.string().nullish(),
  homeOffice: z.string().nullish(),
  id: z.string().uuid(),
  integrationId: z.string().nullish(),
  isActive: z.boolean().nullish(),
  lastLoginAt: z.string().datetime().nullish(),
  lastName: z.string().nullish(),
  locked: z.string().datetime().nullish(),
  notificationsPhoneNumber: z.string().nullish(),
  notificationsPhoneNumberCountry: z.nativeEnum(CountryCode).nullish(),
  notificationsPhoneNumberCountryCode: z.string().nullish(),
  organizationId: z.string().uuid().nullish(),
  password: z.string().nullish(),
  registeredForMfa: z.boolean().nullish(),
  retryAttempts: z.number().int().nullish(),
  roles: z.array(z.nativeEnum(Role)).nullish(),
  salesforceId: z.string().nullish(),
  settings: z.array(z.lazy(() => userSettingSchema)).nullish(),
  termsAndConditionsAcceptedAt: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type User = z.infer<typeof userSchema>;
